import { hooks } from '@lifesize/clients.sdk';

// TODO - Move to SDK if other apps need it? - A hook composed of other existing hooks
const useMutedByServer = (): boolean => {
  const currentUserParticipant = hooks.useCurrentUserParticipant();
  return !!currentUserParticipant && currentUserParticipant.serverMuteState;
};

export default useMutedByServer;
